import {
  IError,
  ISubmitDatas,
} from '../../../types/interface/Assurance/AssuranceVoyage/devis';

export const showErrorValuesDefault = {
  categoryCode: false,
  destinationCode: false,
  dateDebut: false,
  dateFin: false,
  listNaissance: false,
  motif: false,
};
export const showErrorValuesSubmit = {
  categoryCode: true,
  destinationCode: true,
  dateDebut: true,
  dateFin: true,
  listNaissance: true,
  motif: true,
};

export const defaultValues: ISubmitDatas = {
  category: '',
  destination: '',
  dateDebut: '',
  dateFin: '',
  listNaissance: [],
  motif: '',
  type: [],
};

export const defaultErrorValues: IError = {
  categoryCode: '',
  destinationCode: '',
  dateDebut: '',
  dateFin: '',
  listNaissance: '',
  motif: '',
};
